import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as M from 'mapbox-gl';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { MapComponentService } from '../map/map.component.service';
import { MapComponent } from '../map/map.component';
import { EVENT_EMITTERS, MAP_CONSTANTS, PRODUCT_NAMES } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v3',
	templateUrl: './map-v3.component.html',
	styleUrls: ['./map-v3.component.css'],
	providers: [MapComponentService]
})
export class MapV3Component extends MapComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() tertiarykey;
	@Input() uniqueoverwriteid: string;
	@Input() geofencegeovideocallattibutekey: any;
	public geofenceCenterDetails: any = {};
	public showLiftData = false;
	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 2
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 3
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 4
		},
		{
			productName: 'SOCIAL',
			productKey: MAP_CONSTANTS.STATE.SOCIAL,
			isDisabled: true,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSocial'],
			order: 4
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: true,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		},
		{
			productName: 'EMAIL',
			productKey: MAP_CONSTANTS.STATE.EMAIL,
			isDisabled: true,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasEmail'],
			order: 8
		}
	];

	/**
	 *
	 * @type {{productName: string; productKey: string; showInLegend: boolean; show: boolean; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected GF_PRODUCTS = [
		{
			productName: 'GeoFence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'Georecency',
			productKey: 'georecency',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'GeoVideo',
			productKey: 'geovideo',
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasGeoVideo']
		}
	];

	public hasLiftData = false;
	public overallLiftData;
	public singleProductSeledted = false;
	/**
	 * Map Style
	 * @type {string}
	 */
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjj95z173036e2rlw1fwy7tjl';
	protected mapFillColor = 'rgba(255, 255, 255,0.45)';
	protected mapFillOutlineColor = 'rgb(255,255,255)';

	public circleMarkerStyles = {
		'circle-color': '#484848',
		'circle-radius': 6,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	public mapGeofenceIcon = '../../../../assets/images/geofence.png';
	public mapZipIcon = '../../../../assets/images/nav.png';
	public reloadLiftSubscription;
	public widgetDataSubscription;
	public geoVideoMarkers = [];
	public geoVideoRecencyLayersDrawn = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestLiftStats();
		});
	}

	ngOnInit() {
		super.ngOnInit();
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 28;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
		this.defaultMapZoom = 3.2;
		this.requestLiftStats();
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.setMapHeight();
			super.ngAfterViewInit();
		}, 10);
	}

	setMapHeight() {
		const parentHeight = jQuery('.map-v3-container').height();
		const mapHeight = (parentHeight * 75) / 100;
		jQuery('#map').css('height', mapHeight);
	}
	protected processLegendSelection() {
		const nonDependentLegendItems = _.where(this.legendItems, { isDependent: false });
		let gfProducts = _.filter(this.legendItems, (product: any) => {
			return product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO || product.productKey === MAP_CONSTANTS.STATE.GEOFENCE;
		});
		const selectedLegendItems = _.where(nonDependentLegendItems, { isSelected: true });
		let selectedGFLegend = _.where(gfProducts, { isSelected: true });
		let gfProduct;
		if (nonDependentLegendItems.length > 1) {
			const displayProduct = _.findWhere(selectedLegendItems, { productKey: MAP_CONSTANTS.STATE.DISPLAY });
			if (gfProducts) {
				if (selectedGFLegend.length === 0) {
					gfProduct = gfProducts[0];
					if (gfProduct.isDisabled && this.displayGeoFenceData.features.length > 0) {
						gfProduct.isDisabled = !gfProduct.isDisabled;
						gfProduct.isSelected = !gfProduct.isDisabled;
					}
				} else if (selectedGFLegend.length >= 1) {
					gfProduct = selectedGFLegend[0];
					if (gfProduct.isDisabled && this.displayGeoFenceData.features.length > 0) {
						gfProduct.isDisabled = !gfProduct.isDisabled;
						gfProduct.isSelected = !gfProduct.isDisabled;
					}
				}
			}
		}
		if (selectedLegendItems.length === 0) {
			this.hasOnlyGeoFenceSelected = gfProduct ? gfProduct.isSelected : false;
			if (this.hasOnlyGeoFenceSelected) {
				this.noRegionData = false;
			} else {
				this.noRegionData = true;
			}
		}
		if (gfProduct) {
			this.toggleGeoFenceData(gfProduct.isSelected);
		}
	}
	protected drawMap() {
		this.processResponseData();
		if (!_.isEmpty(this.displayGeoFenceData)) {
			this.drawGeoFencePoints();
			this.drawGeoRecencyLayer();
		} else {
			this.removeAllGeoFenceMarkers();
			this.removeGeoFenceRecencyLayer();
		}

		if (!_.isEmpty(this.prerollGeoFenceData)) {
			this.drawGeoVideoPoints();
			this.drawGeoVideoRecencyLayer();
		} else {
			this.removeAllGeoVideoMarkers();
			this.removeGeoVideoRecencyLayer();
		}
		this.showLoad = false;
	}

	removeAllGeoVideoMarkers() {
		this.removeGeoVideoMarker();
	}

	/**
	 *
	 */
	protected removeGeoVideoMarker() {
		for (const marker of this.geoVideoMarkers) {
			marker.remove();
		}
	}

	removeGeoVideoRecencyLayer() {
		if (this.geoVideoRecencyLayersDrawn) {
			this.removeMapLayer('geovideo_points_georecency');
		}
	}

	/*
		Need to refactor R1 map and include all these drawGeoVideoRecencyLayer,removeGeoVideoRecencyLayer, removeGeoVideoMarker, removeAllGeoVideoMarkers and similar geofence functions into 1.
	*/
	drawGeoVideoRecencyLayer() {
		this.geoVideoRecencyLayersDrawn = true;
		this.removeMapLayer('geovideo_points_georecency');
		this.removeMapSource('geovideo_points_georecency');
		if (this.map && !this.map.getLayer('geovideo_points_georecency')) {
			if (this.prerollGeoRecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'geovideo_points_georecency',
					type: 'circle',
					source: {
						type: 'geojson',
						data: this.prerollGeoRecencyData
					},
					paint: {
						'circle-color': '#D1D4D5',
						'circle-stroke-width': 1,
						'circle-stroke-color': '#304150'
					}
				});
			}
		}
	}

	/**
	 * Show geofence center data on hover
	 * @param geofenceCenterPoint - geofence center object
	 */
	showGeoVideoCenterDetails(geofenceCenterPoint) {
		clearTimeout(this.detailsTimeInterval);
		this.showPolygonLayerDetailsFlag = false;
		this.showGeofenceCenterDetailsFlag = true;
		jQuery('.map-details-container').css('display', 'block');
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);

		for (const geofenceFeatureObj of this.prerollGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}

		if (this.minimap) {
			if (this.minimap.getSource('minimap-data')) {
				if (
					Object.keys(this.detailMapPoints.geometry).length === 0 &&
					this.detailMapPoints.geometry.constructor === Object
				) {
					this.detailMapPoints.geometry = {
						type: 'MultiPoint',
						coordinates: []
					};
				}
				this.minimap.getSource('minimap-data').setData(this.detailMapPoints);
			} else {
				this.minimap.addSource('minimap-data', {
					type: 'geojson',
					data: this.detailMapPoints
				});
				this.minimap.addLayer({
					id: 'minimap-points',
					type: 'circle',
					source: 'minimap-data',
					paint: this.circleMarkerStyles
				});
			}
			this.setMapBounds(this.minimap, this.detailMapPoints, false);
		}
		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
	}

	private drawGeoVideoPoints() {
		this.removeAllGeoVideoMarkers();
		this.prerollGeoFenceData.features.forEach((marker) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.backgroundPosition = 'center';
			el.style.backgroundSize = 'cover';
			el.style.width = 30 + 'px';
			el.style.height = 30 + 'px';
			el.addEventListener('mouseover', (event) => {
				this.showGeoVideoCenterDetails(marker.properties);
			});

			el.addEventListener('mouseleave', (event) => {
				this.hideGeoVideoCenterDetails();
				if (marker.properties.is_simplifi_restricted_geopoint) {
					jQuery('.geofence-disclaimer').css('display', 'block');
				}
			});

			// add marker to map
			const gfMarker = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);
			this.geoVideoMarkers.push(gfMarker);
		});
	}

	/**
	 * Hide geofence center data on hover out
	 */
	protected hideGeoVideoCenterDetails() {
		this.detailsTimeInterval = setTimeout(() => {
			this.showGeofenceCenterDetailsFlag = false;
			jQuery('.map-details-container').css('display', 'none');
			jQuery('.geofence-disclaimer').css('display', 'none');
		});
	}

	protected hideLocationDataOnMouseout() {
		this.showPolygonLayerDetailsFlag = false;
		this.polygonLayerDetails = {};
	}

	requestLiftStats() {
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest('LIFT_OVERVIEW_ALL')
			.subscribe((res: any) => {
				this.showLoad = false;
				if (res.success) {
					this.processLiftResponseData(res.data);
				}
			});
	}

	processLiftResponseData(response: any) {
		response = response[0];
		if (
			response.average_lift != null ||
			response.average_conversion_rate != null ||
			response.average_baseline != null
		) {
			this.overallLiftData = response;
			this.overallLiftData.avgLift = response.average_lift;
			this.overallLiftData.averageBaseline = response.average_baseline;
			this.overallLiftData.averageExposeRate = response.average_conversion_rate;
			//this.polygonLayerDetails = this.overallLiftData;
			this.hasLiftData = true;
		} else {
			this.hasLiftData = false;
		}
	}

	selectedProductLegendDetails(item) {
		this.noRegionData = false;
		this.selectedProductDetails(item.legendItem);
		const nonDependentLegendItems = _.where(this.legendItems, { isDependent: false });
		const selectedLegendItems = _.where(nonDependentLegendItems, { isSelected: true });
		this.showLiftData = this.showLiftDetails(selectedLegendItems).length > 0 ? true : false;
		if (selectedLegendItems.length === 1 && selectedLegendItems[0].productKey === 'social') {
			this.singleProductSeledted = true;
		} else {
			this.singleProductSeledted = false;
		}
	}

	showLiftDetails(selectedProducts) {
		return _.filter(selectedProducts, (product: any) => {
			return (
				(product.productName === 'Display' && product.productSelected) ||
				(product.productName === 'Pre Roll' && product.productSelected)
			);
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.reloadLiftSubscription) {
			this.reloadLiftSubscription.unsubscribe();
		}
	}

	onResize(event) {
		this.setMapHeight();
		super.onResize(event);
	}
}
